import { useMutation } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const createHashtag = async (payload: { name: string }) => {
	const url = "/hashtag/";
	const response = await cmsClient.post<{ name: string }>(url, payload);

	return response.data;
};

const useCreateHashtag = () => {
	const mutation = useMutation(createHashtag);

	return mutation;
};

export default useCreateHashtag;
